import { render, staticRenderFns } from "./Comparativa.vue?vue&type=template&id=6604bf1e&"
import script from "./Comparativa.vue?vue&type=script&lang=js&"
export * from "./Comparativa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports